<template>
  <div class="container bottom-fix-padding">
    <div class="weui-navbar daojia-navbar">
        <div class="daojia-navbar-left"><span class="icon-chevron-left" @click="goback()"></span></div>
        <h1 class="daojia-navbar-middle daojia-navbar-middle_logo"><a href="#"><img src="../../assets/img/misc/logo.svg"></a></h1>
        <div class="daojia-navbar-right">
        </div>
    </div>
    <div class="initializing" v-show="isLoading">
      <img src="../../assets/img/misc/loading.svg">
      <div>正在加载中..</div>
    </div>
    <div class="main" v-show="!isLoading">
      <swiper :options="swiperOption" ref="swiper">
        <swiper-slide v-for="(item, index) in meta.oss_banner" :key='index'><div class="imgshow"><img :src='item'></div></swiper-slide>
        <br>
        <div class="swiper-pagination"  slot="pagination"></div>
      </swiper>

      <div class="item-box">
        <div class="text">
          <div class="name">
            {{meta.title}}
          </div>
          <div class="desc">
            {{meta.sub_title}}
          </div>
        </div>
        <div class="price" v-if="meta.price>0">
          {{meta.price | numeral('$0,0.0')}}<span class="small"> 起</span>
        </div>
        <div class="price" v-else>
         <span class="pending">价格现场估算</span>
        </div>
      </div>  
      <div class="promise">
        <div><span class="icon-check-circle color-orange"></span> 当天上门</div>
        <div><span class="icon-check-circle color-orange"></span> 三月质保</div>
        <div><span class="icon-check-circle color-orange"></span> 专业师傅</div>
        <div><span class="icon-check-circle color-orange"></span> 合理报价</div>
      </div>
      <div class="service-info">
      <span class="info-title">温馨提示：</span><br>

      <div>1. 师傅上门检测后，若情况与您说的不符，最终收费将根据实际维修项目多退少补</div>
      <div>2. 师傅上门后，若用户主动放弃服务或者因自身原因导致服务未完成，需要<span class="color-orange">收取 $60 出车上门费用</span></div>
      <div>3. 此费用为维修费用，不包括配件费用；配件可以自行购买或让师傅代买</div>
      <div>4. 服务保障：<span class="color-orange">保修3个月</span></div>
      <div>5. 因不可抗力、使用不当、人为损坏、渗水、墙体结构裂缝等原因导致的损坏，不在保修范围内。自备材料不予保修，特此说明。</div>

      </div>
      <!-- <div class="content" v-html="meta.content">
      </div> -->
      <div class="btn-box-fix">
        <div class="btn-container">
          <div class="btn active" @click="orderUpdateAll('/misc-step1?id='+$route.query.id)" >立即预约</div>
        </div>
      </div>
    </div>

    <img :src="pixelURL('move','chexing')" class="hide">
  </div>
</template>

<script>
import qs from 'qs'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'step2',
  data () {
    return {
      isLoading:false,
      order:{
        service:'misc',
        data:{
            token:0,
            type_id:"1550735980",
            address_name:"",
            address_phone:"",
            address_street:"",
            address_suburb:"",
            address_postcode:"",
            address_state:"NSW",
            address_unit:"",
            service_date:"",
            service_period:"",
            parking:"",
            msg:"",
            price:"",
            service_txt:"",
            hk_service_id:"",
            floor:"",
            order_source:"3",
            coupon_id:"",
            couponLocked:"",
            couponValue:0,
        },
        temp:{
            isAM:'',
            isPM:'',
            isDate:''
        },
      },
      meta:{
        banner:"",
        content:"",
        id:"",
        oss_banner:"",
        price:"",
        sub_title:"",
        type_id:"",
        title:"",
      },
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
        }
      },
    }
  },

  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper: function () {
      return this.$refs.swiper.swiper;
    },

  },
  created: function () {
    let dataObject={};
    let that = this;
    dataObject.service_id = this.$route.query.id;
    this.isLoading = true;
    this.axios.post(this.apiURL()+'/Globals/hk_service', qs.stringify(dataObject))
    .then(function (response) {
      if(response.data.error_code==0){
        that.meta = response.data.data;
        that.order.data.price = that.meta.price;
        that.order.data.service_txt = that.meta.name;
        that.sleep(500).then(() => {
          that.isLoading = false;
        });
      }
      else{
      }
    })
    .catch(function (error) {
        console.log(error)
        alert("服务加载失败，请检查网络并重新尝试")
        that.isSending=false;
    });
  },
  mounted: function () {
  },
  methods: {
    changeSlide(key){
      key = key - 1;
      this.swiper.slideTo(key, 200, false)
    },
    goback(){
      this.$router.push('/')
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container{
  padding-top:50px;
}

.container /deep/ .swiper-button-prev, .container /deep/ .swiper-button-next{
  font-size:2.4em;
  color:#bbb;
  margin-right: 18px;
}

.container /deep/ .swiper-pagination-bullet-active{
  background: $color-orange;
}

.container /deep/ .swiper-button-prev, .container /deep/ .swiper-container-rtl .swiper-button-next{
  background:none;
}

.container /deep/ .swiper-button-next, .container /deep/ .swiper-container-rtl .swiper-button-prev{
  background:none;
}
.imgshow{
  text-align:center;
  img{
    width:100%;
    height:60vw;
  }
}
.car-detail{
  margin-top:20px;
  font-size:0.9em;
  color:#666;
  text-align:center;
  .icon-point{
    color:#fe9567;
  }
}
.car-choose{
  border-bottom:1px solid #eee;
  width:86%;
  margin:1em auto 1.8em auto;
  display: flex;
  justify-content:space-around;
  .car{
    padding:0 0.2em 0 0.2em;
    font-size:0.9em;
  }
  .car.active{
    color:#fe9567;
    border-bottom: solid 3px #fe9567;
    padding-bottom:0.6em;
  }
}

.fade-leave-active {
  transition-duration: 0s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.check-detail{
  border: 2px solid #e3e3e3;
  padding: 8px 18px 8px 14px;
  margin-top: 14px;
  display: inline-block;
  border-radius: 50px;
    -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-name: breathe;
    -webkit-animation-duration: 1000ms;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-direction: alternate;
}

.car-info{
  padding: 10px 30px 0 30px;
  text-align:left;
  color:#999;
  font-size:0.9em;
  display: flex;
  justify-content:space-around;
}


.daojia-navbar {
    position: fixed;
    background: rgba(255, 255, 255, 0.95);
    padding: 8px 10px;
    box-sizing: border-box;
    height: 50px;
}

.daojia-navbar-left {
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: left;
    span{
      font-size: 2em;
      color: #666;
    }
}

.daojia-navbar-middle_logo img{
    height:28px;
    padding-top:2px;
}

.daojia-navbar-middle {
    display: block;
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    flex: 2;
    font-smoothing: antialiased;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    font-family: sans-serif;
    font-size: 1.2em;
    line-height: 1.3;
    font-weight: bold;
}

.daojia-navbar-right {
    font-size: 14px;
    line-height: 26px;
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: right;
}


@-webkit-keyframes breathe {
    0% {
      border: 2px solid #eeeeee;
    }

    100% {
      border: 2px solid #fad0be;
    }
}

.item-box{
  display: flex;
  justify-content:space-between;
  margin:10px 0 14px 0;
  .text{
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    flex: 2;
    padding:10px 15px;
    .name{
      font-weight:bold;
      font-size:1.2em;
    }
    .desc{
      font-size:0.9em;
      color:#666;
    }
  }
  .price{
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    color:$color-orange;
    font-weight:bold;
    font-size:1.5em;
    padding-top:20px;
    .small{
      font-size:14px;
    }
    .pending{
      font-size:15px;
      border:1px solid #ddd;
      padding:8px 4px;
    }
  }
}

.promise{
  font-size:0.84em;
  display: flex;
  justify-content:space-between;
  padding:12px 15px;
  background-color:#f7f7f7;
}

.initializing{
  text-align:center;
  padding-top:50px;
  img{
    width:30%;
  }
}

.service-info{
  color:#888;
  font-size:0.9em;
  padding:14px;
  div{
    margin-top:10px;
  }
}

.info-title{
  font-size:18px;

}
</style>



// WEBPACK FOOTER //
// src/pages/misc/detail.vue